import styled from 'styled-components'
import { colors } from '../../styles'

export const StyledBreadcrumbs = styled.p`
  align-items: center;
  display: flex;
  svg {
    font-size: 12px;
    margin: 4px 4px 0 4px;
  }
  margin: 0;
`

export const StyledCrumb = styled.span`
  & > a {
    color: ${colors.grey};
    font-size: 12px;
    font-family: knowledge2017regular;
    font-weight: bold;
    line-height: 14px;

    text-decoration: none;
  }
`

export const StyledColoredText = styled.span`
  color: ${({ theme }) => (theme ? colors[theme] : colors.portal)};
`
